var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExpandChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.508 5.707l-4.2-4A.973.973 0 010 1C0 .744.103.488.308.293c.41-.39 1.075-.39 1.484 0L5.25 3.586 8.708.293c.41-.39 1.075-.39 1.484 0a.966.966 0 010 1.414l-4.2 4c-.41.39-1.075.39-1.484 0z",
    fill: "#000"
  })));
}
export default SvgIconExpandChevron;